module.exports = __webpack_public_path__ + "static/jumbotron-background-eb72868a10a74d24bf7440a3a4b7354b.svg";